import React from 'react';
import styles from '../style.module.scss';

const t = {
  meters: 'm',
};

const MaxWidth = ({ cellData }) => {
  return (
    <div className={styles.rightCell}>
      {cellData && cellData > 0 ? (
        <span className={styles.relativeCell}>
          {cellData} {t.meters}
        </span>
      ) : null}
    </div>
  );
};

export default MaxWidth;
